import {
  ESAProjectExportable,
  PageAction,
  ProgrammingProjectReportType,
} from 'spw-redux/modules/reports/types';

export const REPORT_TYPES: {
  [key: string]: ProgrammingProjectReportType;
} = {
  PROGRAM_SUMMARY: 'programSummary',
};

export const PROJECT_EXPORTABLE: { [key: string]: ESAProjectExportable } = {
  PROGRAM_SUMMARY: 'programSummary',
};

export const FILE_CABINETS = [
  [
    '1 High Lateral File Cabinets',
    '2 High Lateral File Cabinets',
    '3 High Lateral File Cabinets',
    '4 High Lateral File Cabinets',
    '5 High Lateral File Cabinets',
    '6 High Lateral File Cabinets',
    '7 High Lateral File Cabinets',
  ],
  [
    '1 High Vertical File Cabinets',
    '2 High Vertical File Cabinets',
    '3 High Vertical File Cabinets',
    '4 High Vertical File Cabinets',
    '5 High Vertical File Cabinets',
    '6 High Vertical File Cabinets',
    '7 High Vertical File Cabinets',
  ],
];

export const LOCKERS = [
  '1 High Lockers',
  '2 High Lockers',
  '3 High Lockers',
  '4 High Lockers',
  '5 High Lockers',
  '6 High Lockers',
  '7 High Lockers',
];

export const CUSTOM_SPACE_TYPE_NAME_INPUT_WIDTH = 206;

export enum PROGRAM_SUMMARY_CARDS {
  KEY_DATA_POINTS = 'keyDataPoints',
  HEADCOUNT_ANALYSIS = 'headcountAnalysis',
  SEAT_COUNT_ANALYSIS = 'seatCountAnalysis',
  HEADCOUNT_USF = 'headcountUsf',
  SEAT_COUNT_USF = 'seatCountUsf',
  TOTAL_PROGRAM_ALLOCATION = 'totalProgramAllocation',
  SPACE_TYPE_ALLOCATION = 'spaceTypeAllocation',
  SQUARE_FOOTAGE_BREAKDOWN = 'squareFootageBreakdown',
  MEETING_SEAT_RATIO = 'meetingSeatRatio',
  PROJECT_OVERVIEW = 'projectOverview',
}

export enum MACRO_PROGRAM_SUMMARY_CARDS {
  SPACE_TYPE_ALLOCATION_SUBTOTAL_PROGRAM_USF = 'spaceTypeAllocationSubtotalProgramUsf',
  SPACE_TYPE_ALLOCATION_IW_USF = 'spaceTypeAllocationIWUsf',
  SEAT_TYPE_MIX_IW = 'seatTypeMixIW',
}

export const MACRO_PROGRAM_SUMMARY_CARD_WIDTH: Record<string, number> = {
  projectOverview: 361,
  keyDataPoints: 240,
  headcountAnalysis: 481,
  seatCountAnalysis: 481,
  headcountUsf: 361,
  seatCountUsf: 361,
  spaceTypeAllocationSubtotalProgramUsf: 361,
  spaceTypeAllocationIWUsf: 361,
  seatTypeMixIW: 361,
  squareFootageBreakdown: 361,
  totalProgramAllocation: 361,
  spaceTypeAllocation: 361,
  meetingSeatRatio: 361,
  usfMix: 840,
  individualWorkspacesUsfMix: 481,
  seatMix: 481,
  seatMixSubtotals: 481,
  ratios: 601,
};

export const PROGRAM_SUMMARY_CARD_WIDTH: Record<string, number> = {
  keyDataPoints: 720,
  headcountAnalysis: 361,
  seatCountAnalysis: 361,
  headcountUsf: 361,
  seatCountUsf: 361,
  totalProgramAllocation: 361,
  spaceTypeAllocation: 361,
  squareFootageBreakdown: 361,
  meetingSeatRatio: 361,
  projectOverview: 241,
  usfMix: 720,
  seatMix: 481,
  ratios: 712,
};

const clickShowCardsAction: PageAction = {
  action: 'CLICK',
  selector: '#show-cards',
};

export const PROGRAM_SUMMARY_CARD_ACTIONS: Record<string, PageAction[]> = {
  keyDataPoints: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#keyDataPoints' },
  ],
  headcountAnalysis: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#headcountAnalysis' },
  ],
  seatCountAnalysis: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#seatCountAnalysis' },
  ],
  headcountUsf: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#headcountUsf' },
  ],
  seatCountUsf: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#seatCountUsf' },
  ],
  totalProgramAllocation: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#totalProgramAllocation' },
  ],
  spaceTypeAllocation: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#spaceTypeAllocation' },
  ],
  squareFootageBreakdown: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#squareFootageBreakdown' },
  ],
  meetingSeatRatio: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#meetingSeatRatio' },
  ],
  projectOverview: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#projectOverview' },
  ],
  programSummaryReport: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#programSummaryReport',
    },
    {
      action: 'WAIT_FOR_HIDDEN_STATE',
      selector: '.MuiList-root',
    },
  ],
  spaceTypeAllocationSubtotalProgramUsf: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#spaceTypeAllocationSubtotalProgramUsf',
    },
  ],
  spaceTypeAllocationIWUsf: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#spaceTypeAllocationIWUsf' },
  ],
  seatTypeMixIW: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#seatTypeMixIW' },
  ],
};
